<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-avatar
        v-if="$auth.user && $auth.user.role"
        :color="$auth.user.role.COLOR"
        size="36"
        style="cursor: pointer"
        v-on="on"
      >
        <v-icon>
          {{ $auth.user.role.ICON }}
        </v-icon>
      </v-avatar>
    </template>

    <v-card tile>
      <v-toolbar color="grey lighten-3" flat tile>
        <v-avatar
          v-if="$auth.user && $auth.user.role"
          :color="$auth.user.role.COLOR"
          size="36"
          class="mr-2"
        >
          <v-icon>
            {{ $auth.user.role.ICON }}
          </v-icon>
        </v-avatar>
        <v-toolbar-title class="body-1">
          <p class="title mb-0">
            {{ $auth.user.FIRST_NAME }}
          </p>
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="menu = false">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-toolbar>
      <v-list dense class="pb-0">
        <v-list-item nuxt to="/profile">
          <v-list-item-icon>
            <v-icon>mdi-account-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("My Profile") }}</v-list-item-title>
        </v-list-item>
        <v-list-item nuxt to="/apps">
          <v-list-item-icon>
            <v-icon>mdi-web</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("Applications") }}</v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t("Logout") }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  data() {
    return {
      menu: false,
    };
  },
  methods: {
    async logout() {
      await this.$auth.logout();
    },
  },
};
</script>

<style lang="scss" scoped></style>
